import { systemFontScale } from '@kcd/app-interface';

import { isServer } from './ssr';

export const changedByFontScale = () => systemFontScale() >= 1.3;

export function initFontScale() {
  if (!isServer()) return;

  const style = document.createElement('style');
  const systemFont = systemFontScale();
  style.innerText = `body {
       text-size-adjust: ${systemFont * 100}%;
       -webkit-text-size-adjust: ${systemFont * 100}%;
     }`;
  const head = document.getElementsByTagName('head')[0];
  head.appendChild(style);
}
